<template>
  <div class="pop-drop" ref="popdropper">
    <small-button large arrow v-on:click="toggleSelectingLocation" :sel="location !== 'ZZ'">{{ $nippets.allArtists.location + locationString }}</small-button>
    <transitionable-panel class="popup" :activated="selectingLocation" collapse>
      <div v-for="region in regions" :key="region.code" class="pop-item" 
        :class="{sel: region.code === location }"
        v-on:click.stop="changeRegion(region)">{{ region.name }}</div>
    </transitionable-panel>
  </div>
</template>

<script>
import TransitionablePanel from '@/components/widgets/TransitionablePanel.vue'
import { setTimeout } from 'timers';

export default {
  components: {
    TransitionablePanel
  },
  props: {
    value: String
  },
  data () {
    return {
      selectingLocation: false,
      location: 'ZZ',
      regions: [
        {
          code: 'ZZ',
          name: this.$nippets.allArtists.all
        },
        {
          code: 'UK',
          name: this.$nippets.allArtists.uk
        },
        {
          code: 'US',
          name: this.$nippets.allArtists.us
        },
        {
          code: 'DE',
          name: this.$nippets.allArtists.europe
        },
        {
          code: 'CN',
          name: this.$nippets.allArtists.china
        },
        {
          code: 'AU',
          name: this.$nippets.allArtists.oz
        }
      ]
    }
  },
  computed: {
    locationString () {
      if(this.location === 'ZZ') return ''
      let reg = this.regions.find(el => el.code === this.location)
      if(reg) {
        return ': ' + reg.name
      }
      return ''
    }
  },
  created () {
    this.location = this.value
  },
  mounted: function () {
    document.body.addEventListener('click', (e) => {
      if(this.selectingLocation) {
        if(!this.$refs.popdropper.contains(e.target)){
          this.selectingLocation = false
        }
      }
      
    })
  },
  methods: {
    toggleSelectingLocation: function () {
      this.selectingLocation = !this.selectingLocation
    },
    changeRegion: function (region) {
      this.$emit('input', region.code)
      setTimeout(() => {
        this.selectingLocation = false
      }, 500)
    }
  },
  watch: {
    value () {
      this.location = this.value
    }
  }
}
</script>

<style scoped>
.pop-drop{
  position:relative;
  display:inline-block;
  margin-left:5px;
}

.pop-drop .popup{
  position:absolute;
  top:100%;
  left:0;
  z-index:45;
  background-color:#fff;
  box-shadow:2px 2px 3px rgba(0,0,0,0.3);
  box-sizing:border-box;
}

.pop-drop .pop-item{
  padding:4px 10px 4px 24px;
  cursor:pointer;
  user-select: none;
}

.pop-drop .pop-item.sel{
  background-image:url('../../assets/img/circle.svg');
  background-repeat:no-repeat;
  background-size:auto 40%;
  background-position-x:5px;
  background-position-y:center;
  color:#ce0e2d;
}

.pop-drop .pop-item:hover {
  color:#ce0e2d;
}

@media screen and (max-width:640px){
  .pop-drop{
    margin-left:0;
  }
}
</style>
